module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/sliding-door/slidingDoor.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/sliding-door/slidingDoor.png
// module id = 491
// module chunks = 0